module.exports = __webpack_public_path__ + "static/img/2mobile.d988c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2mobile.jpg
// module id = CsjM
// module chunks = 1